export default __webpack_public_path__ + "static/media/compatible-woocommerce.00ff64ba.svg";